<template>
    <comHeader></comHeader>
        <!-- inner banner -->
        <div class="inner-banner">
        <div class="w3l-breadcrumb">
            <div class="container">
                <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">Our Services</h4>
                <ul class="breadcrumbs-custom-path">
                    <li><a href="/">Home</a></li>
                    <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>Services</li>
                </ul>
            </div>
        </div>
    </div>
    <!-- //inner banner -->

    <section class="w3l-about-2 py-5">
        <div class="container py-md-5 py-4">
            <div class="row align-items-center justify-content-between ">
                <div class="about-2-secs-left pr-lg-5">
                    <h1 class="title-style mb-sm-3 mb-2">1. How does the Smart ID tag work?</h1>
                    <div></div>
                    <p class="w3l-grids-block-5 font-stle">The tag uses a QR code to link directly to your pet's information. If your pet is found, anyone can scan or tap the tag with their smartphone to get their information and contact you.
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">2. How do I create my pet's profile?</h3>
                    <ul>
                        <li>1. Scan the QR code on the product</li>
                        <li>2. Register an account or sign in with your Facebook or Google account</li>
                        <li>3. Click Add Tag.</li>
                        <li>4. Edit the tag information and save</li>
                        <li>5. Registration is complete</li>
                    </ul>
                    <h3 class="title-style mb-sm-3 mb-2 title">3.How to use QR code for pet ID tag?</h3>
                    <p>QR code pet tags are a type of digital pet ID tag. Instead of a printed name and phone number, these tags come with a QR code that links to the pet owner's contact information. 
                        When someone scans the code, they get the pet owner's contact information. Thus, they can seamlessly contact the owner and inform them about their pet.</p>
                    <div>
                        <ul>
                            <li>
                                <p>Step 1</p>
                                <p>Get a pet ID tag and create a profile for your pet.
                                Link the profile and tag to keep your contact information and important information about your pet up-to-date.</p>
                            </li>
                            <li>
                                <p>Step 2</p>
                                <p>If your pet goes missing.
                                    Make sure you have all key information enabled so that finders can view them through your pet's profile.</p>
                            </li>
                            <li>
                                <p>Step 3</p>
                                <p>Finder scans tags or accesses profiles online.
                                    Anyone with a smartphone can scan a tag or access your pet's profile online to see your contact information and important information about your pet.</p>
                            </li>
                            <li>
                                <p>Step 4</p>
                                <p>Reunite with your pet.
                                    With contact details, the finder can contact you immediately and your pet can be returned home more quickly.</p>
                            </li>
                        </ul>
                    </div>
                    <h3 class="title-style mb-sm-3 mb-2 title">4. Do I need a subscription?</h3>
                    <p>
                        No! Smart ID has no subscription fees or hidden costs.
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">5. What information can I add to my pet's profile?</h3>
                    <p>You can include your pet's name, your contact information, medical information, and any special instructions that will help keep your pet safe.</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">6. Can I use it without an app?</h3>
                    <p>Yes, there is no need to download a page. The tag works with any smartphone that can scan QR code.</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">7. Is my information secure?</h3>
                    <p>Yes, your details are stored securely and Personal data can be set in hidden mode without authorization.</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">8. What if I need to update my pet's information?</h3>
                    <p>You can update your pet's details at any time by scanning the QR code to log into your account.</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">9. Does this tag track my pet's location?</h3>
                    <p>No, the Smart ID Tag is not a GPS tracker. It helps you reconnect with your pet by providing your contact information to the person who finds your pet.</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">10. Is it valid worldwide?</h3>
                    <p>Yes, the tag can be scanned or tapped anywhere in the world.</p>
                    <h3 class="title-style mb-sm-3 mb-2 title">11. What do I do if I can't receive the verification code?</h3>
                    <div>
                        <ul>
                            <li>1). Please verify that the email address you entered is correct. </li>
                            <li>2). Check the spam and promotional email folders for the code.</li>
                            <li>3). Your mailbox is low on space.</li>
                            <li>4). Please click the message button on the top right of the homepage for customer service.</li>
                        </ul>
                    </div>
                    <h3 class="title-style mb-sm-3 mb-2 title">13. What should I do if the activation code is wrong or has been used?</h3>
                    <p>Please check if you have received the correct activation code. For example, the letter S is similar to the number 5 and the letter B is similar to the number 8. If you have entered the correct activation code and it still shows incorrect activation code, If the QR code does not work, please contact customer service or the merchant from whom you purchased the site.
                    </p>
                    <h3 class="title-style mb-sm-3 mb-2 title">14. How do I change the e-mail for my account?</h3>
                    <p>You can log in to your account and delete the label on the “My Tags” page. Then scan the QR code on the tab and re-register a new account with a new email address.</p>
                </div>
            </div>
        </div>
    </section>

  </template>
  
  <script>
  import comHeader from '../components/comHeader.vue';

  export default {
    name: 'appSupport',
    components:{
      comHeader
    }
  }
  </script>
  
  <style scoped>
  /* 可添加样式 */
  </style>